module.exports = __webpack_public_path__ + "coupon-code.svg?c4219fdeab5914ed1b88084fe2ef80d5";